export const DEFAULT_PAGE_SIZE_OPTIONS = ['10', '20', '50', '75', '100']
